import Vue from 'vue'
import Router from 'vue-router'
import CompleteOrder from '@/presentationals/v1/views/order/CompleteOrder.vue'
import SendReceipt from '@/presentationals/v1/views/my/order/SendReceipt.vue'
import PaymentApproval from '@/presentationals/v1/views/payment/Approval.vue'
import OrderFail from '@/presentationals/v1/views/order/OrderFail.vue'
import PaymentClose from '@/presentationals/v1/views/payment/PaymentClose.vue'
import Receipt from '@/presentationals/v1/views/receipt/Receipt.vue'

// ###########################################################

import V2Cart from '@/presentationals/v2/pages/cart/CartPage.vue'
import V2PreOrder from '@/presentationals/v2/pages/order/PreOrderV2Page.vue'
import V2OrderHistory from '@/presentationals/v2/pages/my/order/OrderHistoryPage.vue'
import V2OrderHistoryDetail from '@/presentationals/v2/pages/my/order/OrderHistoryDetailPage.vue'
import V2ChatbotOrderHistoryDetail from '@/presentationals/v2/pages/my/order/ChatbotOrderHistoryDetailPage.vue'
import V2Error from '@/presentationals/v2/pages/common/ErrorPage.vue'
import CashReceipt from '@/presentationals/v2/pages/receipt/CashReceiptPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/payment/close',
      name: 'PaymentClose',
      component: PaymentClose
    },
    {
      path: '/order/fail',
      name: 'OrderFail',
      component: OrderFail
    },
    {
      path: '/payment/approval/:paymentId',
      name: 'PaymentApproval',
      component: PaymentApproval
    },
    {
      path: '/my/order/history/:orderId',
      name: 'OrderHistoryDetail',
      component: V2OrderHistoryDetail
    },
    {
      path: '/my/order/history',
      name: 'OrderHistory',
      component: V2OrderHistory
    },
    {
      path: '/my/order/send-receipt/:paymentKey',
      name: 'OrderSendReceipt',
      component: SendReceipt
    },
    {
      path: '/cart',
      name: 'Cart',
      component: V2Cart
    },
    {
      path: '/order/pre-order/:key',
      name: 'PreOrderV2',
      component: V2PreOrder
    },
    {
      path: '/order/complete',
      name: 'CompleteOrder',
      component: CompleteOrder
    },
    {
      path: '/receipts/:type',
      name: 'Receipt',
      component: Receipt
    },

    // V2 ===================================

    {
      path: '/v2/cart',
      name: 'V2/Cart',
      component: V2Cart
    },

    {
      path: '/v2/pre-order/:key',
      name: 'V2/PreOrder',
      component: V2PreOrder
    },

    {
      path: '/v2/my/order/history',
      name: 'V2/OrderHistory',
      component: V2OrderHistory
    },

    {
      path: '/v2/my/order/history/:orderId',
      name: 'V2/OrderHistoryDetail',
      component: V2OrderHistoryDetail
    },

    {
      path: '/chatbot/order-history/:orderId',
      name: 'V2/ChatbotOrderHistoryDetail',
      component: V2ChatbotOrderHistoryDetail
    },

    {
      path: '/my/order/cash-receipt/:paymentKey',
      name: 'CashReceipt',
      component: CashReceipt
    },

    {
      path: '/*',
      name: 'Error',
      component: V2Error
    }
  ]
})
